
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/rEditor/rootComps/selectionBox/editBox/layout/components/LayoutWidthIndicator.scss.css.virtualfile';
        module.exports = {"container":"_container_156g8_1","outside":"_outside_156g8_18","left":"_left_156g8_20","text":"_text_156g8_25"};